<template>
  <div class="mt-4">
    <h4>{{ this.headerTitle }} {{ $t('message.address') }}</h4>
    <div class="form-row">
      <div class="form-group col-md-12">
        <label for="addressinput">{{ $t('message.streetAddress') }}</label>
        <vue-google-autocomplete
          id="OO_addressinput"
          name="OO_addressinput"
          ref="gAutoComplete"
          :enable-geolocation="true"
          class="form-control"
          @change="setStreetAddress"
          @placechanged="getAddressData"
          :country="['au']"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-4">
        <label for="Postcode">{{ $t('message.postcode') }}</label>
        <input
          v-validate="'required|numeric'"
          id="postInput"
          v-model="editModel.PostalCode"
          name="Postcode"
          @keydown="isDeliveryAreaValid=true"
          @change="validatePostcode(editModel.PostalCode)"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Postcode") }}</div>
        <div
          class="text-danger"
          v-if="!isDeliveryAreaValid"
        >{{ $t('message.deliveryNotAvailableFor') }} {{editModel.PostalCode}}</div>
      </div>
      <div class="form-group col-sm-4">
        <label for="Suburb">{{ $t('message.suburb') }}</label>
        <input
          v-validate="'required'"
          id="Suburb"
          v-model="editModel.CityTown"
          name="Suburb"
          type="text"
          class="form-control"
        />
        <div class="invalid-feedback">{{ OOErrors.first("Suburb") }}</div>
      </div>
      <div class="form-group col-sm-4">
        <label for="State">{{ $t('message.state') }}</label>
        <select
          v-validate="'required'"
          id="State"
          name="State"
          v-model="editModel.State"
          type="text"
          ref="stateRef"
          class="form-control"
        >
          <option v-for="(state,index) in states" :key="index" :value="state">{{state}}</option>
        </select>
        <div class="invalid-feedback">{{ OOErrors.first("State") }}</div>
      </div>
    </div>
    <div class="form-row" v-if="!isGift">
      <div class="form-group col-md-12">
        <label for="insInput">{{ $t('message.deliveryInstructions') }}</label>
        <input
          id="insInput"
          v-model="editModel.DeliveryInstructions"
          type="text"
          class="form-control"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";
import shared from "../../../../sharedscripts/shop/Checkout/partials/DeliveryAddress.js";
import { mapGetters } from "vuex";
export default {
  components: {
    VueGoogleAutocomplete
  },
  props: {
    editModel: {
      type: Object,
      default: () => {}
    },
    headerTitle: {
      type: String,
      default: "Delivery"
    }
  },
  data() {
    return {
      address: {
        street_number: "",
        route: "",
        locality: ""
      },

      states: [
        "Select your state",
        "ACT",
        "NSW",
        "NT",
        "QLD",
        "SA",
        "TAS",
        "VIC",
        "WA"
      ],
      isDeliveryAreaValid: true
    };
  },
  mounted() {
    if (this.editModel.State == "") {
      this.editModel.State = this.states[0];
      this.$refs.stateRef.options[0].selected = true;
    }
  },
  updated() {
    if (this.editModel.StreetAddress) {
      document.getElementById(
        "OO_addressinput"
      ).value = this.editModel.StreetAddress;
    }
  },
  computed: {
    ...mapGetters(["isGift", "currentStoreDoc"]),
    ...shared.computed
  },
  methods: {
    ...shared.methods
  }
};
</script>
